import { render, staticRenderFns } from "./assemble-positioning-device-info-modal.vue?vue&type=template&id=2cb4fc0e"
import script from "./assemble-positioning-device-info-modal.vue?vue&type=script&lang=js"
export * from "./assemble-positioning-device-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports